export { default as Likely } from './likely'
